import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import { rem, Spacer } from 'design-system';
import { useAppSelector } from 'store/hooks';
import SectionHeader from 'design-system/SectionHeader';
import { selectFundInfo } from '../reducers/selectors';
import FundThemeCategorizationCard from './FundThemeCategorizationCard';
const ThemedAssetCategorizationView = () => {
    const fundsInfo = useAppSelector(selectFundInfo);
    if (!fundsInfo?.length) {
        return null;
    }
    return (<>
      <Spacer h={8}/>
      <SectionHeader horizontalMargins>Themes</SectionHeader>
      <View style={styles.container}>
        {fundsInfo.map((fundInfo) => (<FundThemeCategorizationCard fundInfo={fundInfo} key={fundInfo.fundInfo.title}/>))}
      </View>
    </>);
};
export default React.memo(ThemedAssetCategorizationView);
const styles = StyleSheet.create({
    container: {
        flexWrap: 'wrap',
        flexDirection: 'row',
        gap: rem(16),
        marginVertical: rem(12),
        marginHorizontal: rem(16),
    },
});
